import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const AUTHORITY_SITE = 'https://aiaccountabilitycouncil.com';

export default function LegalFooter() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <footer className="border-t border-zinc-200 bg-white mt-auto">
      <div className="container mx-auto px-6 py-8">
        {/* Institutional Positioning Statement */}
        <div className="text-center mb-8 pb-6 border-b border-zinc-100">
          <p className="text-sm text-zinc-600 max-w-3xl mx-auto">
            This platform administers Standards Alignment Declarations and AASC declaration processes 
            in accordance with the published standards of the{' '}
            <a 
              href={AUTHORITY_SITE}
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-900 hover:underline inline-flex items-center gap-1"
            >
              AI Accountability Standards Council
              <ExternalLink className="w-3 h-3" />
            </a>.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-sm text-zinc-500">
            <span>&copy; {new Date().getFullYear()} AI Accountability Standards Council</span>
          </div>

          <div className="flex items-center gap-6 text-sm">
            {/* AI Risk Assessment Link */}
            <Link to="/assessment" className="text-zinc-500 hover:text-zinc-900">
              AI Risk Score
            </Link>
            
            {/* Authority Site Links */}
            <a 
              href={`${AUTHORITY_SITE}/standards`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-zinc-900 flex items-center gap-1"
            >
              Standards <ExternalLink className="w-3 h-3" />
            </a>
            <a 
              href={`${AUTHORITY_SITE}/governance-and-authority`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-zinc-900 flex items-center gap-1"
            >
              Governance <ExternalLink className="w-3 h-3" />
            </a>
            
            {/* Platform Links */}
            <Link to="/terms" className="text-zinc-500 hover:text-zinc-900">
              Terms
            </Link>
            <Link to="/privacy" className="text-zinc-500 hover:text-zinc-900">
              Privacy
            </Link>
            <Link to="/withdrawal-policy" className="text-zinc-500 hover:text-zinc-900">
              Withdrawal Policy
            </Link>
            
            {/* Hidden Admin Link */}
            <Link 
              to="/admin/login" 
              className="text-zinc-300 hover:text-zinc-400 text-xs"
              aria-label="Admin"
            >
              •
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
